import { useEffect, useState } from "react";
import { formatarDataBrasil } from "../../utils/utils";
import "./AssociarPagamento.css";

export default function AssociarPagamento() {
  const [pagamentos, setPagamentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cobrancaDuplicada, setCobrancaDuplicada] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [currentPagamento, setCurrentPagamento] = useState(null);

  useEffect(() => {
    async function fetchPagamentosNaoAssociados() {
      try {
        const response = await fetch("https://welaunchyou.com.br/crm-wly/api/financeiro/listar_pagamentos_nao_associados.php");
        const data = await response.json();
        console.log("📥 Pagamentos não associados carregados:", data);
        console.log("🔍 Dados brutos do backend:", data);


        if (data.success) {
          setPagamentos(data.pagamentos);
        } else {
          console.error("Erro ao buscar pagamentos não associados:", data.message);
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchPagamentosNaoAssociados();

  }, []);

  async function handleAssociarPagamento(pgto) {
    console.log("📢 Tentando associar pagamento:", pgto);
    console.log("📌 Verificando dados antes de setar currentPagamento:", pgto);


    try {
        const response = await fetch("https://welaunchyou.com.br/crm-wly/api/financeiro/associar_pagamento.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id_transacao_asaas: pgto.id_transacao_asaas,
                id_faturamento: pgto.id,
                id_cliente_asaas: pgto.id_cliente_asaas,
                valor: pgto.valor,
                confirmacao: false,  // Primeira tentativa, sem confirmação ainda
            }),
        });

        const result = await response.json();
        console.log("📩 Resposta da API:", result);

        if (!result.success && result.sugerir_criacao) {
            console.log("⚠️ Nenhuma cobrança correspondente encontrada. Sugerindo criação.");
        
            if (window.confirm("Nenhuma cobrança correspondente encontrada. Deseja criar uma nova cobrança?")) {
                setCurrentPagamento((prev) => ({
                    ...prev,
                    ...pgto,  // Mantém os valores do objeto original e adiciona os novos
                    id_cliente_asaas: pgto.id_cliente_asaas ?? prev?.id_cliente_asaas,  // Garante que o valor não seja sobrescrito com undefined
                }));
                 // Atualiza o estado
            }
            return;
        }
        
        
        

        if (!result.success && result.cobranca_norea) {
            console.log("🛠 Cobrança encontrada no banco:", result.cobranca_norea);
            console.log("📌 Verificando dados do pagamento antes de setar currentPagamento:", pgto);

            if (!pgto.id_cliente_asaas) {
                console.error("🚨 Erro: id_cliente_asaas está ausente no pagamento!", pgto);
                alert("Erro: id_cliente_asaas não encontrado.");
                return;
            }

            setCurrentPagamento(pgto);
            console.log("✅ currentPagamento atualizado:", pgto);

            setCobrancaDuplicada({
                id: result.cobranca_norea.id,
                cliente_nome: result.cobranca_norea.cliente_nome || "Nome não encontrado",
                valor: result.cobranca_norea.valor || "0.00",
                status: result.cobranca_norea.status || "Desconhecido",
                id_transacao_asaas: result.cobranca_norea.id_transacao_asaas || "Não informado"
            });

            // 🔹 Garante que o estado é atualizado antes de abrir o modal
            setTimeout(() => {
                setShowConfirmModal(true);
                console.log("📢 Modal de confirmação agora deve aparecer.");
            }, 100);
        } else if (result.success) {
            alert("Pagamento associado com sucesso!");
            setPagamentos(pagamentos.filter(item => item.id !== pgto.id));
        } else {
            alert("Erro ao associar pagamento: " + result.message);
        }
    } catch (error) {
        console.error("Erro ao associar pagamento:", error);
        alert("Erro ao associar pagamento. Verifique o console para mais detalhes.");
    }
}



async function handleCriarCobranca() {
    if (!currentPagamento) {
        console.error("❌ Nenhum pagamento selecionado para criar nova cobrança!");
        return;
    }

    // Verifica se id_cliente_asaas está definido antes de enviar
    if (!currentPagamento.id_cliente_asaas) {
        console.error("🚨 Erro: id_cliente_asaas não encontrado em currentPagamento!", currentPagamento);
        alert("Erro: id_cliente_asaas não está presente.");
        return;
    }

    const payload = {
        id_cliente_asaas: currentPagamento.id_cliente_asaas,
        valor: currentPagamento.valor,
        id_transacao_asaas: currentPagamento.id_transacao_asaas,
    };

    console.log("📤 Enviando dados para criar_cobranca.php:", payload);

    try {
        const response = await fetch("https://welaunchyou.com.br/crm-wly/api/financeiro/criar_cobranca.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        const text = await response.text();
        console.log("📩 Resposta bruta da API:", text);

        const result = JSON.parse(text);
        console.log("📩 Resposta da API ao criar cobrança:", result);

        if (result.success) {
            alert("Cobrança criada com sucesso!");
        } else {
            alert("Erro ao criar cobrança: " + result.message);
        }
    } catch (error) {
        console.error("Erro ao criar cobrança:", error);
        alert("Erro ao criar cobrança. Verifique o console.");
    }
}



useEffect(() => {
    if (currentPagamento !== null) {
        console.log("📤 Estado de currentPagamento atualizado:", currentPagamento);

        if (!currentPagamento.id_cliente_asaas) {
            console.error("🚨 Erro: id_cliente_asaas não encontrado após atualização!", currentPagamento);
        } else {
            setTimeout(() => handleCriarCobranca(), 200);  // Pequeno delay para garantir atualização
        }
    }
}, [currentPagamento]);







  async function handleConfirmacaoAssociacao() {
    if (!currentPagamento) {
      console.error("❌ Nenhum pagamento selecionado para confirmar!");
      return;
    }

    console.log("🚀 Confirmando associação de pagamento:", currentPagamento);

    try {
      const response = await fetch("https://welaunchyou.com.br/crm-wly/api/financeiro/associar_pagamento.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_transacao_asaas: currentPagamento.id_transacao_asaas,
          id_faturamento: currentPagamento.id,
          id_cliente_asaas: currentPagamento.id_cliente_asaas,
          valor: currentPagamento.valor,
          confirmacao: true,  // Agora confirmando a associação
        }),
      });

      const result = await response.json();
      console.log("📩 Resposta da API após confirmação:", result);

      if (result.success) {
        alert("Pagamento associado com sucesso!");
        setPagamentos(pagamentos.filter(item => item.id !== currentPagamento.id));
      } else {
        alert("Erro ao associar pagamento: " + result.message);
      }
    } catch (error) {
      console.error("Erro ao confirmar associação:", error);
      alert("Erro ao confirmar associação. Verifique o console para mais detalhes.");
    } finally {
      setShowConfirmModal(false);
      setCurrentPagamento(null);
      setCobrancaDuplicada(null);
    }
  }

   return (
    <div className="associar-pagamento-container">
      <h1>Associar Pagamento</h1>
      <h2>Pagamentos não associados</h2>
      {loading ? (
        <p className="loading-text">Carregando...</p>
      ) : (
        <table className="tabela-pagamentos">
          <thead>
            <tr>
              <th>ID Transação</th>
              <th>Cliente</th>
              <th>Valor</th>
              <th>Data</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {pagamentos.length > 0 ? (
              pagamentos.map((pgto) => (
                <tr key={pgto.id}>
                  <td>{pgto.id_transacao_asaas}</td>
                  <td>{pgto.cliente_nome || "Não identificado"}</td>
                  <td>R$ {parseFloat(pgto.valor).toFixed(2)}</td>
                  <td>{formatarDataBrasil(pgto.data_pagamento)}</td>
                  <td>
                  <button className="associar-btn" onClick={() => handleAssociarPagamento(pgto)}>
  Associar
</button>

                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="no-pagamento-text">
                  Nenhum pagamento pendente
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      {showConfirmModal && (
        <div className="modal" style={{ display: "block", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 9999}}>
          <div className="modal-content">
            <h3>Confirmação de Associação</h3>
            <p>Uma cobrança similar foi encontrada. Deseja associá-la?</p>

            {cobrancaDuplicada && (
  <div className="cobranca-info">
    <h4>🔎 Cobrança Encontrada no Nórea CRM</h4>
    <p><strong>Cliente:</strong> {cobrancaDuplicada.cliente_nome || "Nome não encontrado"}</p>
    <p><strong>Valor:</strong> R$ {cobrancaDuplicada.valor ? parseFloat(cobrancaDuplicada.valor).toFixed(2) : "0.00"}</p>
    <p><strong>Status:</strong> {cobrancaDuplicada.status || "Desconhecido"}</p>
    <p><strong>ID Transação:</strong> {cobrancaDuplicada.id_transacao_asaas || "Não informado"}</p>
  </div>
)}


            <button onClick={handleConfirmacaoAssociacao} className="confirmar-btn">
              Sim, associar
            </button>
            <button onClick={() => setShowConfirmModal(false)} className="cancelar-btn">
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
